export const authors = [
    "François Tshipuki",
    "Cédrick Aundu",
    "Fady Koyabambi",
    "Manassé Mbala",
    "Masand Mafuta",
    "Merveille Bushu",
    "Marcus Kasembe",
    "Nelvie Mola",
    "Joshua Nsiala",
    "Audrey Mbungu",
    "Berger Mushibi",
    "Colette Zaina",
    "Emery Kabongo",
    "Jeremie Ndibu",
    "Yves Muetu",
    "Elias Lwayivweka"
]

export const startOfMonth = new Date(
    new Date().getFullYear(),
    new Date().getMonth(),
    1
).getTime();
export const endOfMonth = new Date(
    new Date().getFullYear(),
    new Date().getMonth() + 1,
    0
).getTime();
